<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="13.5" viewBox="0 0 13.5 13.5">
    <g id="ic-layout-content-left" transform="translate(0.459 0.459)">
      <line
        id="Line_251"
        data-name="Line 251"
        x2="12"
        transform="translate(0.291 0.291)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_252"
        data-name="Line 252"
        x2="4"
        transform="translate(8.291 3.291)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_253"
        data-name="Line 253"
        x2="3"
        transform="translate(8.291 6.291)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_254"
        data-name="Line 254"
        x2="3"
        transform="translate(8.291 9.291)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_255"
        data-name="Line 255"
        x2="3"
        transform="translate(8.291 12.291)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <rect
        id="Rectangle_65"
        data-name="Rectangle 65"
        width="5"
        height="9"
        rx="1"
        transform="translate(0.291 3.291)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
    </g>
  </svg>
</template>
